import * as bootstrap from 'bootstrap'

import Form from './_form';
import Gsap from './_gsap';
import Header from './_header';

new Form;  
new Gsap;  
new Header;  